import { useEffect, useRef } from 'react';
import { getQueryParam } from 'modules/main/utils';
import { ClientPageType } from 'src/app/types';
import { gtmPushScrollAutomatically } from './scroll';

export const useGtmAutomaticallyScrollBody = (
  pushGtmEvent: typeof gtmPushScrollAutomatically,
  currentPage: number,
  pageType?: ClientPageType,
) => {
  const wasScrolled = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (wasScrolled.current) {
        return;
      }

      pushGtmEvent({
        currentPage,
        pageType,
      });
      wasScrolled.current = true;
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageType]);

  useEffect(() => {
    /** Reset the flag to allow sending the event when scrolling on the next page */
    wasScrolled.current = false;
  }, [currentPage]);
};

export const useGtmAutomaticallyScroll = (pageType?: ClientPageType) =>
  useGtmAutomaticallyScrollBody(
    gtmPushScrollAutomatically,
    Number(getQueryParam('page')) || 1,
    pageType,
  );
